import verge from 'verge'
import throttle from 'lodash/throttle'

const SELECTORS = Selectors({
  indicator: '[data-scroll-indicator]',
  header: 'site-header',
  active: 'is-active'
})

const props = {
  $indicators: document.querySelectorAll(SELECTORS.indicator),
  $header: document.querySelector(SELECTORS.asClass('header'))
}

const fn = {
  init: () => {
    fn.bindEvents()
    fn.handleScroll()
  },

  bindEvents: () => {
    window.addEventListener('scroll', throttle(fn.handleScroll, 20))
  },

  handleScroll: () => {
    if (window.matchMedia('(min-width: 768px)').matches) {
      const scrollY = verge.scrollY() - props.$header.offsetHeight

      const $selected = Array.from(props.$indicators).reduce(($prev, $curr) => {
        const prevCoords = verge.rectangle($prev)
        const currCoords = verge.rectangle($curr)
        const prevDiff = Math.abs(prevCoords.top - scrollY)
        const currDiff = Math.abs(currCoords.top - scrollY)

        return prevDiff < currDiff ? $prev : $curr
      })

      props.$indicators.forEach($el => $el.classList.remove(SELECTORS.active))

      $selected.classList.add(SELECTORS.active)
    }
  }
}

export default {
  can: () => props.$indicators.length,
  run: fn.init
}
